// This module imports the Angular Material componenets we'll be using as basis for Exlibris apps UI
import { NgModule } from '@angular/core';
import {MATERIAL_SANITY_CHECKS} from '@angular/material/core';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
//import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatSliderModule} from '@angular/material/slider';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatTableModule} from '@angular/material/table';

@NgModule({
    imports: [
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatTooltipModule,
        MatListModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatRadioModule,
        MatExpansionModule,
        MatStepperModule,
        MatMenuModule,
        MatSidenavModule,
        MatButtonToggleModule,
        MatSlideToggleModule,
        MatChipsModule,
        MatDialogModule,
        MatCardModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatDatepickerModule,
      //  MatNativeDateModule,
        MatMomentDateModule,
        MatTabsModule,
        MatSnackBarModule,
        MatBottomSheetModule,
        MatSliderModule,
        MatTableModule
    ],
    exports: [
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatTooltipModule,
        MatListModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatRadioModule,
        MatExpansionModule,
        MatStepperModule,
        MatMenuModule,
        MatSidenavModule,
        MatButtonToggleModule,
        MatSlideToggleModule,
        MatChipsModule,
        MatDialogModule,
        MatCardModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatDatepickerModule,
     //   MatNativeDateModule,
        MatMomentDateModule,
        MatTabsModule,
        MatSnackBarModule,
        MatBottomSheetModule,
        MatSliderModule,
        MatTableModule
    ],
    providers: 	[
        {
            provide: MATERIAL_SANITY_CHECKS,
            useValue: false
        }
    ]
})

export class EsploroMaterialModule {}
